import React from "react";

export function parseBoldText(text) {
  const parts = text.split(/(<b>|<\/b>)/g); // separamos por las etiquetas
  let isBold = false;

  return parts.map((part, index) => {
    if (part === "<b>") {
      isBold = true;
      return null;
    }
    if (part === "</b>") {
      isBold = false;
      return null;
    }
    return isBold ? (
      <strong key={index}>{part}</strong>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    );
  });
}

export function getValueByKey(objArray, searchKey, searchValue, returnKey) {
  const found = objArray.find(item => item[searchKey] === searchValue);
  return found ? found[returnKey] : undefined;
}


export function getTextFromChildren(children: React.ReactNode): string {
  let out = '';
  React.Children.forEach(children, (child) => {
    if (typeof child === 'string' || typeof child === 'number') {
      out += String(child);
    } else if (Array.isArray(child)) {
      out += getTextFromChildren(child);
    } else if (React.isValidElement(child)) {
      out += getTextFromChildren(child.props?.children);
    }
  });
  return out.replace(/\s+/g, ' ').trim();
}

export function toSnakeCase(label: string): string {
  return label
    .toLowerCase()
    .normalize('NFC')
    .replace(/\(.*?\)|\[.*?\]|\{.*?\}/g, '')
    .replace(/[^\p{L}\p{N}]+/gu, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
}

const TZ_CLT = "America/Santiago";

/**
 * Normaliza un valor de fecha proveniente de la API y devuelve un Date (instante).
 * Si el string no trae indicador de zona horaria, se asume UTC (así lo entrega la API).
 * Retorna null si no es parseable.
 */
export function parseUtcDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  let s = String(value).trim().replace(" ", "T");
  // si no trae zona horaria (Z u offset ±HH:MM), asumir UTC
  if (!/([zZ]|[+-]\d{2}:?\d{2})$/.test(s)) s += "Z";

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Fecha UTC → "YYYY-MM-DD" en hora de Chile (CLT). Retorna null si no es parseable. */
export function formatCltDate(value) {
  const d = parseUtcDate(value);
  if (!d) return null;
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ_CLT,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}

/** Fecha UTC → "YYYY-MM-DD HH:mm" en hora de Chile (CLT). Retorna null si no es parseable. */
export function formatCltDateTime(value) {
  const d = parseUtcDate(value);
  if (!d) return null;
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ_CLT,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .format(d)
    .replace(",", "");
}

export function toSnakeCaseNoAccents(label: string): string {
  const noDiacritics = label
    .normalize('NFD')
    .replace(/[\u0300-\u036f\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/g, '');

  return noDiacritics
    .toLowerCase()
    .replace(/\(.*?\)|\[.*?\]|\{.*?\}/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
}